<template>
  <div>
    <v-select
      v-model="emailMethod"
      :items="emailMethods"
      :label="$t('Type')"
      item-text="text"
      item-value="id"
    ></v-select>
    <v-row v-show="showSmtpMethod">
      <v-col cols="12" md="6">
        <v-text-field
          v-model="wizard.emailSettings.emailServer"
          v-bind:label="$t('Server')"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          :min="1"
          v-bind:label="$t('Port')"
          v-model="wizard.emailSettings.emailPort"
          :error-messages="emailPortErrors"
          @input="validator.wizard.emailSettings.emailPort.$touch()"
          @blur="validator.wizard.emailSettings.emailPort.$touch()"
          type="number"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-text-field
          v-model="wizard.emailSettings.emailAccount"
          v-bind:label="$t('User')"
          :error-messages="emailAccountErrors"
          @input="validator.wizard.emailSettings.emailAccount.$touch()"
          @blur="validator.wizard.emailSettings.emailAccount.$touch()"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6">
        <v-text-field
          v-show="showSmtpMethod"
          v-model="wizard.emailSettings.emailPassword"
          v-bind:label="$t('Password')"
          type="password"
          :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
        ></v-text-field>
        <v-text-field
          v-show="!showSmtpMethod"
          v-model="wizard.emailSettings.sendGridApiKey"
          :label="$t('API KEY')"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <v-switch
          v-show="showSmtpMethod"
          color="primary"
          v-model="wizard.emailSettings.emailUseSSL"
          v-bind:label="$t('SSL')"
        ></v-switch>
      </v-col>
      <v-col cols="12" md="6">
        <v-btn :loading="loading" color="warning" @click="test">{{
          $t("Test")
        }}</v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OrganizationService from '@/services/OrganizationService';
import Utils from '@/ecm/common/Utils';
export default {
    props: {
        wizard: {
            type: Object,
            default: () => ({}),
        },
        validator: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            loading: false,
            showPassword: false,
            emailMethod: 0,
            emailMethods: [
                { id: 0, text: 'SMTP' },
                { id: 1, text: 'SendGrid' },
            ],
        };
    },
    computed: {
        showSmtpMethod() {
            return this.emailMethod == 0;
        },
        emailAccountErrors() {
            const errors = [];
            if (!this.validator.wizard.emailSettings.emailAccount.$dirty) return errors;
            !this.validator.wizard.emailSettings.emailAccount.email &&
                errors.push(`${this.$t('InvalidEmail')}`);
            return errors;
        },
        emailPortErrors() {
            const errors = [];
            if (!this.validator.wizard.emailSettings.emailPort.$dirty) return errors;
            !this.validator.wizard.emailSettings.emailPort.minValue &&
                errors.push(`${this.$t('MinValue')}: 1`);
            return errors;
        },
    },
    methods: {
        test() {
            if (!this.wizard.emailSettings.emailAccount) {
                Utils.toast.error(`${this.$t('RequiredField')}: ${this.$t('User')}`);
                return;
            }
            if (!this.validator.wizard.emailSettings.emailAccount.email) {
                Utils.toast.error(
                    `${this.$t('InvalidEmail')}: ${this.wizard.emailSettings.emailAccount}`
                );
                return;
            }

            if (this.emailMethod == 1) {
                if (!this.wizard.emailSettings.sendGridApiKey) {
                    Utils.toast.error(
                        `${this.$t('RequiredField')}: ${this.$t('API KEY')}`
                    );
                    return;
                }
            }

            if (this.emailMethod == 0) {
                if (!this.wizard.emailSettings.emailServer) {
                    Utils.toast.error(
                        `${this.$t('RequiredField')}: ${this.$t('Server')}`
                    );
                    return;
                }
                if (this.wizard.emailSettings.emailPort <= 0) {
                    Utils.toast.error(`${this.$t('RequiredField')}: ${this.$t('Port')}`);
                    return;
                }
                if (!this.wizard.emailSettings.emailPassword) {
                    Utils.toast.error(
                        `${this.$t('RequiredField')}: ${this.$t('Password')}`
                    );
                    return;
                }
            }

            this.loading = true;
            OrganizationService.testEmailConfig(this.wizard.emailSettings.toDto())
                .then((data) => {
                    Utils.toast.success(this.$t('EmailSent'));
                })
                .catch(() => {
                })
                .then(() => {
                    //always
                    this.loading = false;
                });
        },
    },
};
</script>

<style>
</style>
